import { createServer, Model, RestSerializer } from 'miragejs';
import {
  acceptAgreement,
  activateLicense,
  checkEdge,
  confirmHybrid,
  getBillingProfile,
  getDefaultPrompts,
  getHybrid,
  getTenantProfile,
  getWhatNext,
  getWhatNextSkype,
  initialize,
  login,
  logout,
  requestTrial,
  updateBillingProfile,
  updateHybrid,
} from './responses';
import { getConsoleLogger } from '../util/logger';

const consoleLogger = getConsoleLogger('server');

// mock bureaucrat server
const createMockServer = () => {
  createServer({
    serializers: {
      application: RestSerializer.extend({
        root: false,
        embed: true,
      }),
    },
    models: {
      tenant: Model,
      hybridSetting: Model,
    },
    seeds(server) {
      initialize(server);
    },
    routes() {
      // to introduce some network latency,
      // uncomment the code below
      // this.timing = 3000;
      this.get('/whatNext', (schema, request) => {
        consoleLogger.debug('whatNext');
        return getWhatNext(schema, request);
      });

      this.get('/whatNextSkype', (schema, request) => {
        consoleLogger.debug('whatNextSkype');
        return getWhatNextSkype(schema, request);
      });

      this.get('/billing-profile', (schema) => {
        consoleLogger.debug('billing-profile');
        return getBillingProfile(schema);
      });

      this.post('/billing-profile', () => {
        consoleLogger.debug('update billing-profile');
        return updateBillingProfile();
      });

      this.post('/accept-agreement', () => {
        consoleLogger.debug('update accept-agreement');
        acceptAgreement();
      });

      this.post('/activate-license', (schema, request) => {
        consoleLogger.debug('update activate-license');
        activateLicense(schema, request);
      });

      this.get('/hybrid', (schema) => {
        consoleLogger.debug('hybrid');
        return getHybrid(schema);
      });

      this.post('/hybrid', (schema) => {
        consoleLogger.debug('update hybrid');
        return updateHybrid(schema);
      });

      this.post('/hybridConfirm', (schema) => {
        consoleLogger.debug('update hybridConfirm');
        return confirmHybrid(schema);
      });

      this.post('/checkedge', () => {
        consoleLogger.debug('update checkedge');
        return checkEdge();
      });

      this.post('/logs', () => {
        consoleLogger.debug('send logs');
      });

      this.put('/tenants/:id', () => {
        consoleLogger.debug('update tenant');
      });

      this.get('/tenant-profile', (schema, request) => {
        consoleLogger.debug('get profile');
        return getTenantProfile(schema, request);
      });

      this.get('/teams-gw-prompts/tenant', () => {
        consoleLogger.debug('get tenant prompts');
        return getDefaultPrompts();
      });

      this.put('/teams-gw-prompts/tenant', () => {
        consoleLogger.debug('put tenant prompts');
      });

      this.get('/teams-gw-prompts/default', () => {
        consoleLogger.debug('get default prompts');
        return getDefaultPrompts();
      });

      this.post('/login', (schema, request) => {
        consoleLogger.debug('login');
        login(schema, request);
      });

      this.get('/logout', (schema, request) => {
        consoleLogger.debug('login');
        logout(schema, request);
      });

      this.post('/request-trial', () => {
        consoleLogger.debug('post request trial');
        requestTrial();
      });
    },
  });
};

export default createMockServer;
